import { Box, Button, Flex, Heading, Image } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import introductionIcon from '../../assets/image/introduction.png';

interface StartTask {
  onAddNew: () => void;
}

const StartTask = ({ onAddNew }: StartTask) => {
  const { t } = useTranslation();
  return (
    <Flex align='center' justify='center' h='100%'>
      <Flex align='center' direction='column' w='712px'>
        <Image boxSize='64px' mb='16px' alt='introduction' src={introductionIcon} />
        <Box mb='26px' color='color_main_text' textAlign='center'>
          <Heading as={'h2'} my={2} size={'lg'}>
            {t('translator.welcome')}
          </Heading>
          {t('translator.description')}
        </Box>
        <Button
          w='300px'
          h='64px'
          color='#ffffff'
          fontSize='20px'
          borderRadius='30px'
          onClick={onAddNew}
          variant='submit_summary'
        >
          {t('translator.start')}
        </Button>
      </Flex>
    </Flex>
  );
};

export default StartTask;
